import {CHECKBOX_TYPE, CHOICE_TYPE, COLLECTION_TYPE} from "v4/data/fieldTypes";

export function serializeByProperties(formData, keyPrefix, property, value) {
    const {type} = property ?? {};

    if (type === COLLECTION_TYPE) {
        if (!Array.isArray(value) || value.length === 0) {
            formData.append(keyPrefix, '[]');
            return;
        }
        value.forEach((entry, index) =>
            serializeEntryProperties(formData, `${keyPrefix}[${index}]`, property.properties ?? {}, entry));
        return;
    }

    if (type === CHOICE_TYPE) {
        if (property.multiple) {
            (Array.isArray(value) ? value : []).forEach(item => formData.append(`${keyPrefix}[]`, item?.id ?? item ?? ''));
            return;
        }

        const scalar = value?.id ?? value;
        formData.append(keyPrefix, typeof scalar === 'object' ? '' : scalar ?? '');
        return;
    }

    formData.append(keyPrefix, value ?? (type === CHECKBOX_TYPE ? false : ''));
}

export function serializeEntryProperties(formData, prefix, properties, data, options = {}) {
    const {skipFields = [], defaults = {}} = options;
    const containers = Object.keys(properties)
        .filter(name => properties[name]?.type === undefined)
        .sort((a, b) => b.length - a.length);

    Object.entries(properties).forEach(([fieldName, property]) => {
        if (property?.type === undefined) return;
        if (skipFields.includes(fieldName)) return;

        const container = containers.find(name => fieldName.startsWith(`${name}_`));
        const childKey = container ? fieldName.slice(container.length + 1) : null;
        const path = container ? `${prefix}[${container}][${childKey}]` : `${prefix}[${fieldName}]`;
        const rawValue = container ? data?.[container]?.[childKey] : data?.[fieldName];

        serializeByProperties(formData, path, property, rawValue ?? defaults[fieldName]);
    });
}
